package fr.manyverse.app.presentation.screens

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import fr.manyverse.app.presentation.components.CheckboxRow
import fr.manyverse.app.presentation.theme.Spacing
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.terms_accept_button
import manyverse.shared.generated.resources.terms_accept_checkbox
import manyverse.shared.generated.resources.terms_content
import manyverse.shared.generated.resources.terms_decline_button
import manyverse.shared.generated.resources.terms_title
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun TermsScreen(
    onAccept: () -> Unit,
    onDecline: () -> Unit,
    isLoading: Boolean = false,
    error: StringResource? = null,
    modifier: Modifier = Modifier
) {
    var isChecked by remember { mutableStateOf(false) }

    Surface(
        modifier = modifier.fillMaxSize(),
        color = MaterialTheme.colorScheme.background
    ) {
        Column(
            modifier = Modifier
                .fillMaxSize()
                .statusBarsPadding()
                .navigationBarsPadding()
                .padding(horizontal = Spacing.large, vertical = Spacing.medium)
        ) {
            Text(
                text = stringResource(Res.string.terms_title),
                style = MaterialTheme.typography.headlineMedium,
                color = MaterialTheme.colorScheme.primary,
                modifier = Modifier.testTag("termsTitleText")
            )

            Spacer(modifier = Modifier.height(Spacing.medium))

            LazyColumn(
                modifier = Modifier
                    .weight(1f)
                    .testTag("termsContentList")
            ) {
                item {
                    Text(
                        text = stringResource(Res.string.terms_content),
                        style = MaterialTheme.typography.bodyMedium,
                        color = MaterialTheme.colorScheme.onBackground
                    )
                }
            }

            Spacer(modifier = Modifier.height(Spacing.medium))

            CheckboxRow(
                label = stringResource(Res.string.terms_accept_checkbox),
                checked = isChecked,
                onCheckedChange = { isChecked = it },
                enabled = !isLoading,
                modifier = Modifier.testTag("termsCheckboxRow")
            )

            if (error != null) {
                Text(
                    text = stringResource(error),
                    color = MaterialTheme.colorScheme.error,
                    style = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.padding(vertical = Spacing.compact)
                )
            }

            Spacer(modifier = Modifier.height(Spacing.compact))

            Button(
                onClick = onAccept,
                enabled = isChecked && !isLoading,
                modifier = Modifier
                    .fillMaxWidth()
                    .testTag("termsAcceptButton")
            ) {
                if (isLoading) {
                    CircularProgressIndicator(
                        modifier = Modifier.size(16.dp),
                        color = MaterialTheme.colorScheme.onPrimary,
                        strokeWidth = 2.dp
                    )
                } else {
                    Text(stringResource(Res.string.terms_accept_button))
                }
            }

            Spacer(modifier = Modifier.height(Spacing.compact))

            OutlinedButton(
                onClick = onDecline,
                enabled = !isLoading,
                modifier = Modifier
                    .fillMaxWidth()
                    .testTag("termsDeclineButton"),
                colors = ButtonDefaults.outlinedButtonColors(
                    contentColor = MaterialTheme.colorScheme.error
                )
            ) {
                Text(stringResource(Res.string.terms_decline_button))
            }
        }
    }
}
